import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContractListComponent } from './contract-list/contract-list.component';
import { DashboardComponent } from 'src/app/core/layouts/dashboard/dashboard.component';
import { ConfigGeneralComponent } from './config-general/config-general.component';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    children: [
      {path: '', component: ContractListComponent},
      {path: ':contractId', component: ContractListComponent},
      {path: ':contractId/settings', component: ConfigGeneralComponent}
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContractsRoutingModule { }
